import { render, staticRenderFns } from "./YpoConciergeLayout.vue?vue&type=template&id=4755d80e&scoped=true&"
import script from "./YpoConciergeLayout.vue?vue&type=script&lang=js&"
export * from "./YpoConciergeLayout.vue?vue&type=script&lang=js&"
import style0 from "./YpoConciergeLayout.vue?vue&type=style&index=0&id=4755d80e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4755d80e",
  null
  
)

export default component.exports